
export const syncErrorService = {
    prepareSyncErrorPayload: (value, props, exportStatus) => {
        let payload = [{
            exportStatus: exportStatus,
            "packageType": value.package_type ? value.package_type : value.packageType ? value.packageType : undefined,
            "placementCost": {
                "unitAmount": value.unit_amount ? value.unit_amount : value.placementCost && value.placementCost.unitAmount ? value.placementCost.unitAmount : 0,
                "plannedCost": {
                    "amount": value.planned_cost ? value.planned_cost : value.placementCost && value.placementCost.plannedCost.amount ? value.placementCost.plannedCost.amount : null,
                },
                "rate": {
                    "amount": value.rate ? value.rate : value.placementCost && value.placementCost.rate.amount ? value.placementCost.rate.amount : null,
                }
            },
            "client_id": value.client_id ? value.client_id : undefined,
            "placementNumber": value.mediaocean_id ? value.mediaocean_id : value.placementNumber ? value.placementNumber : null,
            "placementTaxonomy": value.placement_taxonomy ? value.placement_taxonomy : value.placementName ? value.placementName : undefined,
            "placementTaxonomyDisplay": value.placement_taxonomy ? value.placement_taxonomy : value.placementName ? value.placementName : undefined,
            
            "taxonomySchema": value.taxonomy_schema ? value.taxonomy_schema : value.taxonomySchema ? value.taxonomySchema : null,
            "placementType": value.cost_method ? value.placement_type : value.placement_type ? value.placementType : undefined,
            "buyCategory": value.buy_category ? value.buy_category : value.buyCategory ? value.buyCategory : undefined,
            "unitType": value.unit_type ? value.unit_type : value.unitType ? value.unitType : undefined,
            "costMethod": value.cost_method ? value.cost_method : value.costMethod ? value.costMethod : undefined,
            "site": value.site ? value.site : undefined,
            "supplierCode": value.supplier_code ? value.supplier_code : value.supplierCode ? value.supplierCode : null,
            "dimensionsPosition": value.dimensions_position ? value.dimensions_position : value.dimensionsPosition ? value.dimensionsPosition : undefined,
            "dimensions": value.dimensions ? value.dimensions : undefined,
            "flightStart": value.flight_start ? value.flight_start : value.flightStart ? value.flightStart : undefined,
            "flightEnd": value.flight_end ? value.flight_end : value.flightEnd ? value.flightEnd : undefined,
            // remove served by dropdown for package's
            "servedBy": value.served_by ? value.served_by : value.servedBy ? value.servedBy : undefined,
            "createdBy": props.omniProfile?.email,
            "data_source": value.data_source ? value.data_source : undefined,
            "primaryPlacement": value.primary_placement ? value.primary_placement : value.primaryPlacement ? value.primaryPlacement : undefined,
            "marketValue": "",
            "provider": value.provider ? value.parameter_code : undefined,
            "parameterCode": value.parameter_code ? value.parameter_code : value.parameterCode ? value.parameterCode : undefined,
            "parameterCodeTaxonomyDisplay": value.parameter_code ? value.parameter_code : value.parameterCode ? value.parameterCode : undefined,
            "parameterCodeTaxonomySchema": value.parameter_code_taxonomy_schema ? value.parameter_code_taxonomy_schema.replace(/_/g, '|') : value.parameterCodeTaxonomySchema ? value.parameterCodeTaxonomySchema.replace(/_/g, '|') : undefined,
            "parentId": value.parent_id ? value.parent_id : value.parentId ? value.parentId : undefined,
            "ad_verification": value.ad_verification ? value.ad_verification : undefined,
            "ad_server": value.ad_server ? value.ad_server : undefined,
        }];

        //if overidden is true then only add overrideTaxonomy and overiddenPlacementTaxonomy
        if(value.override_taxonomy){
            payload[0]["overrideTaxonomy"] = value.override_taxonomy;
            payload[0]["overridenPlacementTaxonomy"] = value.placement_taxonomy;
            payload[0]["overridenPlacementTaxonomyDisplay"] = value.placement_taxonomy_display;
        }
        return payload;
    },
}